// The calendar's day arithmetic, shared by PlanupCalendar.vue and CalendarMonthGrid.vue.
//
// A day is a number, yyyymmdd. The grid's days are local dates; an item's date is "UTC with the
// local wall clock" (item-mapper's convertToUTCSameTime; holidays and booking windows are UTC
// midnight), so an item's day is read from its UTC fields, whatever the browser's time zone.

export function keyOfLocal(date) {
    return date.getFullYear() * 10000 + (date.getMonth() + 1) * 100 + date.getDate();
}

export function keyOfItemDate(value) {
    const date = new Date(value);
    if (isNaN(date.getTime()))
        return null;
    return date.getUTCFullYear() * 10000 + (date.getUTCMonth() + 1) * 100 + date.getUTCDate();
}

export function utcOfKey(key) {
    return Date.UTC(Math.floor(key / 10000), Math.floor(key / 100) % 100 - 1, key % 100);
}

// yyyy-mm-dd of a local date
export function isoOfLocal(date) {
    const month = date.getMonth() + 1, day = date.getDate();
    return date.getFullYear() + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day;
}

// "10:30" → minutes into the day; no time = -1, so an all-day item sorts first
export function minutesOf(time) {
    if (!time || typeof time != 'string')
        return -1;
    const match = time.match(/^(\d{1,2}):(\d{2})/);
    return match ? (+match[1]) * 60 + (+match[2]) : -1;
}

// the day (first .. last) of an item: a multi-day event covers endDate too
export function itemDayRange(item) {
    const start = keyOfItemDate(item.startDate);
    if (!start)
        return null;
    let end = item.endDate ? keyOfItemDate(item.endDate) : start;
    if (!end || end < start)
        end = start;
    return { start: start, end: end };
}

// the items of one day, all-day items first, then by time, ties in the given order
export function itemsOfDay(items, date) {
    const key = keyOfLocal(date);
    const found = [];
    for (let i = 0; i < items.length; i++) {
        const range = items[i] ? itemDayRange(items[i]) : null;
        if (range && key >= range.start && key <= range.end)
            found.push({ item: items[i], sort: minutesOf(items[i].time), order: i });
    }
    found.sort((a, b) => (a.sort - b.sort) || (a.order - b.order));
    return found.map(entry => entry.item);
}
